import { getGatsbyImageData } from 'gatsby-source-sanity';
import clientConfig from '../../client-config';

export default function GetImage(imageAsset, returnSrc) {
  const ImageData = getGatsbyImageData(
    imageAsset,
    { maxWidth: 960 },
    clientConfig.sanity
  );
  return returnSrc ? ImageData.images.fallback.src : ImageData;
}
